import React from "react";
import JobPostingHeader from "./components/JobPostingHeader";
import JobPostingVideo from "./components/JobPostingVideo";
import JobPostingInformation from "./components/JobPostingInformation";
import AboutCompanyHeader from "./components/AboutCompanyHeader";
import AboutCompanyDescription from "./components//AboutCompanyDescription";
import CompanyTeams from "./components/CompanyTeams";
import CompanyLocations from "./components/CompanyLocations";
import FeaturedEmployees from "./components/FeaturedEmployees";
import CompanyBenefits from "./components/CompanyBenefits";
import CompanyValues from "./components/CompanyValues";
import JobPostingFooter from "./components/JobPostingFooter";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderJobPostingPage() {
  return (
    <div className="bg-gray-100 py-2">
      <OrderMainNav />
      <div className="bg-white shadow-xl py-12 rounded-2xl container mx-auto my-6 min-h-full h-full">
        <section className="px-6">
          <JobPostingHeader />
          <JobPostingVideo />
          <JobPostingInformation />
        </section>
        <AboutCompanyHeader />
        <section className="px-6">
          <AboutCompanyDescription />
          <CompanyTeams />
          <CompanyLocations />
          <FeaturedEmployees />
          <CompanyBenefits />
          <CompanyValues />
          <JobPostingFooter />
        </section>
      </div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderJobPostingPage);
